import React from 'react';
import PropTypes from 'prop-types';

import { DeliveryUnitRulesCopy, MinMaxQuantityRule } from '../../components';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { RULESET_MIN, RULESET_MAX } from '~APP_UTIL/formValidations';

export const PdpDeliveryUnitRules = ({ product }) => {
  if (!product) return null;

  const { prePackIndicator, deliveryUnit, deliveryUnitOfMeasure, min, max } = product;
  const prePack = prePackIndicator && deliveryUnit && deliveryUnitOfMeasure;

  return prePack || min || max ? (
    <div className='mt8-sm'>
      <div className='body-2 u-bold'>
        <TranslatedCopy id='pdp.deliveryUnit.title' />
      </div>

      {prePack && (
        <DeliveryUnitRulesCopy
          className='text-color-secondary body-3'
          deliveryUnit={deliveryUnit}
          deliveryUnitOfMeasure={deliveryUnitOfMeasure}
        />
      )}

      {min && <MinMaxQuantityRule type={RULESET_MIN} value={min} />}
      {max && <MinMaxQuantityRule type={RULESET_MAX} value={max} />}
    </div>
  ) : null;
};

PdpDeliveryUnitRules.propTypes = {
  product: PropTypes.object.isRequired
};

export default PdpDeliveryUnitRules;
